export const moveToTypes = {
    INBOX: "Inbox",
    OK: "Ok",
    SHORTLISTED: "Shortlisted",
    TESTDOME: "Testdome",
    HIRED: "Hired"
}